import React from 'react';

const SvgLearning = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 104 104"
}, props), /*#__PURE__*/React.createElement("g", {
  className: "tourlane-Careers-Learning__nc-icon-wrapper"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "tourlane-Careers-Learning__path-1",
  d: "M3 0h49.12a3 3 0 013 3v62.64a3 3 0 01-3 3H9.248v-5.408L0 63.21V3a3 3 0 013-3z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(21 18)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-Careers-Learning__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-Careers-Learning__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#ECECEC",
  xlinkHref: "#tourlane-Careers-Learning__path-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M9.795-.78a.78.78 0 01.772.674l.008.106v50.242a.78.78 0 01-1.553.105l-.007-.105V0c0-.43.349-.78.78-.78zm10.234 16.838a.78.78 0 01.106 1.552l-.106.008h-2.735a.78.78 0 01-.106-1.553l.106-.007h2.735zm7.28 0a.78.78 0 01.106 1.552l-.106.008h-4.815a.78.78 0 01-.106-1.553l.106-.007h4.815zm0-3.64a.78.78 0 01.106 1.552l-.106.008H17.294a.78.78 0 01-.106-1.553l.106-.007H27.31zm-5.2-3.637a.78.78 0 01.106 1.553l-.106.007h-4.815a.78.78 0 01-.106-1.553l.106-.007h4.815zm5.2 0a.78.78 0 01.106 1.553l-.106.007h-2.735a.78.78 0 01-.106-1.553l.106-.007h2.735z",
  mask: "url(#tourlane-Careers-Learning__mask-2)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M26.616 75.616H76.12v11.232H26.616a5.616 5.616 0 110-11.232z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M83.331 42.794a25.93 25.93 0 01-5.227 14.123 1.09 1.09 0 00-.231.318 31.056 31.056 0 01-9.067 7.942C54.496 56.724 54.28 43.365 54.28 42.795V32.637c0-.617.5-1.117 1.117-1.117h26.817c.617 0 1.117.5 1.117 1.117v10.157z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M75.667 41.207a1.117 1.117 0 00-1.58 0L65.8 49.496l-1.305-1.305a1.117 1.117 0 00-1.58 1.58l2.095 2.095a1.117 1.117 0 001.58 0l9.078-9.079a1.117 1.117 0 000-1.58z"
}))));

export default SvgLearning;